<template lang="pug">
  #app
    .nav
      // b-icon.cut-here(icon="content-cut")

      // MY LISTS
      router-link.my-lists(to="/my-lists", v-show="$store.getters.registered")
        b-tooltip(label="Meine Listen", position="is-left")
          b-icon(icon="format-list-numbers")

      // LOGIN AND LOGOUT
      router-link.power(to="/login", v-show="!$store.getters.registered")
        b-tooltip(label="Login", position="is-left")
          b-icon(icon="power")
      router-link.power(to="/login", v-show="$store.getters.registered")
        b-tooltip(label="Logout", position="is-left")
          b-icon(icon="power", @click.native="logout")
    //.tabs.is-centered.block
      ul
        router-link(tag="li", to="/", exact)
          a Home
        router-link(tag="li", to="/my-lists")
          a Listen
    .container.main
      zoom-x-transition(mode="out-in")
        router-view(:key="$route.fullPath")

    footer
      .container
        router-link(to="/impressum") Impressum
</template>

<script>
import BIcon from 'buefy/src/components/icon/Icon'

export default {
  components: { BIcon },
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Deine',
    // all titles will be injected into this template
    titleTemplate: '%s | Wunschliste'
  },
  data () {
    return {
    }
  },
  created () {
    if (localStorage.getItem('token')) {
      this.$store.commit('login', localStorage.getItem('token'))
    }
  },
  methods: {
    logout: function () {
      this.$store.commit('logout')
    }
  },
  computed: {}
}
</script>

<style lang="scss">
$red: #e6041c;

$white: #fff;
$light-grey: #ebebeb;
$grey: #cecece;
$dark-grey: #878786;
$dark-grey-hover: #a4a4a4;
$near-black: #4a4a4a;

$dark-blue: #067db4;
$blue: #5fc5ec;
$light-blue: #56caf4;

$orange: #f59d22;
$green: #79b658;
$green-hover: #499d49;

html, body {
  font-size: 14px !important;
}

#app {
  min-height: 100vh;
  display: grid;
  grid-template-rows: 40px auto 60px
}
body {
  position: relative;
}
footer {
  padding: 20px;
  text-align: right;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.nav {
  box-sizing: border-box;
  border-bottom: 3px dashed #999;
  justify-content: flex-end;
  display: flex;
  text-align: right;
  align-items: center;
  padding: 0 10px
}

.nav a {
  margin-left: 20px;
}

// customizing Buefy
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: $dark-blue;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);
$danger: $red;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($green, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

a.power, a.my-lists {
  width: 24px;
  height: 24px;
}

.container {
  max-width: 900px;
  flex-grow: 1;
}
@media screen and (max-width: 600px) {
  .container {
    min-width: 100%;
  }
}

.button-wrapper {
  text-align: right;
  white-space: nowrap;
  display: flex;
  justify-content: flex-end;
  align-content: space-between;
}
.button + .button { margin-left: 5px; }
</style>
